import React from "react";
import { Card, Row, Col, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { BsBook, BsListCheck, BsTable, BsFileSpreadsheet, BsCalculator } from "react-icons/bs";

export default function RapoarteContabilitate() {
  const navigate = useNavigate();

  return (
    <div className="p-3">
      <Card className="shadow-sm border-0 rounded-4 p-4">
        <h4 className="fw-bold mb-4 text-dark">Rapoarte Contabilitate</h4>
        <Row className="g-4">
          <Col xs={12} sm={6} md={3}>
            <Card className="h-100 border border-light-subtle rounded-4 bg-light shadow-sm">
              <Card.Body className="p-4 d-flex flex-column justify-content-between">
                <div>
                  <div className="text-primary mb-3">
                    <BsBook size={40} />
                  </div>
                  <Card.Title className="fw-bold mb-2">Note Contabile</Card.Title>
                  <Card.Text className="text-secondary small">
                    Vizualizează notele contabile generate automat de facturi, NIR-uri, plăți și încasări sau notele contabile manuale.
                  </Card.Text>
                </div>
                <div className="mt-4">
                  <Button
                    variant="primary"
                    onClick={() => navigate("/nc")}
                    className="fw-semibold px-4 rounded-3"
                  >
                    Mergi la Note Contabile
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Col>

          <Col xs={12} sm={6} md={3}>
            <Card className="h-100 border border-light-subtle rounded-4 bg-light shadow-sm">
              <Card.Body className="p-4 d-flex flex-column justify-content-between">
                <div>
                  <div className="text-info mb-3">
                    <BsListCheck size={40} />
                  </div>
                  <Card.Title className="fw-bold mb-2">Plan de Conturi</Card.Title>
                  <Card.Text className="text-secondary small">
                    Vizualizează și configurează planul de conturi al societății, clasele și conturile analitice/sintetice.
                  </Card.Text>
                </div>
                <div className="mt-4">
                  <Button
                    variant="primary"
                    onClick={() => navigate("/accounts")}
                    className="fw-semibold px-4 rounded-3"
                  >
                    Mergi la Plan de Conturi
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Col>

          <Col xs={12} sm={6} md={3}>
            <Card className="h-100 border border-light-subtle rounded-4 bg-light shadow-sm">
              <Card.Body className="p-4 d-flex flex-column justify-content-between">
                <div>
                  <div className="text-success mb-3">
                    <BsTable size={40} />
                  </div>
                  <Card.Title className="fw-bold mb-2">Balanță de Verificare</Card.Title>
                  <Card.Text className="text-secondary small">
                    Generează balanța de verificare contabilă pe o perioadă dată, în format analitic, sintetic sau cu totaluri pe grupe.
                  </Card.Text>
                </div>
                <div className="mt-4">
                  <Button
                    variant="primary"
                    onClick={() => navigate("/rapoarte/balanta")}
                    className="fw-semibold px-4 rounded-3"
                  >
                    Mergi la Balanță
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Col>

          <Col xs={12} sm={6} md={3}>
            <Card className="h-100 border border-light-subtle rounded-4 bg-light shadow-sm">
              <Card.Body className="p-4 d-flex flex-column justify-content-between">
                <div>
                  <div className="text-warning mb-3">
                    <BsFileSpreadsheet size={40} />
                  </div>
                  <Card.Title className="fw-bold mb-2">Fișă de Cont</Card.Title>
                  <Card.Text className="text-secondary small">
                    Generează fișa de cont pentru analiza detaliată a mișcărilor debit/credit și a soldului conturilor contabile.
                  </Card.Text>
                </div>
                <div className="mt-4">
                  <Button
                    variant="primary"
                    onClick={() => navigate("/rapoarte/fisa-cont")}
                    className="fw-semibold px-4 rounded-3"
                  >
                    Mergi la Fișă Cont
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Col>

          <Col xs={12} sm={6} md={3}>
            <Card className="h-100 border border-light-subtle rounded-4 bg-light shadow-sm">
              <Card.Body className="p-4 d-flex flex-column justify-content-between">
                <div>
                  <div className="text-danger mb-3">
                    <BsCalculator size={40} />
                  </div>
                  <Card.Title className="fw-bold mb-2">Bilanț Contabil</Card.Title>
                  <Card.Text className="text-secondary small">
                    Generează bilanțul contabil (activ/pasiv) pentru a analiza situația patrimonială a societății.
                  </Card.Text>
                </div>
                <div className="mt-4">
                  <Button
                    variant="primary"
                    onClick={() => navigate("/rapoarte/bilant")}
                    className="fw-semibold px-4 rounded-3"
                  >
                    Mergi la Bilanț
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Card>
    </div>
  );
}

